import axios from "axios";
import StorageHelper from "../utils/storageHelper";

// Create axios client, pre-configured with baseURL
let APIKit = axios.create({

  baseURL: `${process.env.REACT_APP_API_BASE_URL}/api/`,
  timeout: 99999999999999999999,
});

APIKit.interceptors.request.use((request) => {

  return request;
});

APIKit.interceptors.response.use((response) => {

  if (response.data &&
    response.data.status === "204" &&
    response.data.message === "Invalid Or Empty Authentication Token") {
    
    StorageHelper.clearAuthDataOnly();
    
    return;
  }
  return response;
});

export default APIKit;